module.exports = new __parcel__URL__("step_four_vector_light.e2c74d49.png").toString();